module.exports = __webpack_public_path__ + "img/wedeliver.9c7c7b33.png";